// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","order_card":"order_card-Uhq6d","persons":"persons-cHFYj"};